import Link from "next/link";
import ImageComponent from "@core/helpers/client/components/image";
import { with_search_query } from "@core/helpers/search-url";

const ProductItemSearch = ({ item, search }) => {
  return (
    <Link
      href={with_search_query(item?.seo_full_url, search)}
      className="flex items-center justify-start cursor-pointer rounded-md border border-b border-jmt-neutral-200 hover:border-jmt-primary-800 transition overflow-hidden p-2"
    >
      <div className="w-14 h-14 overflow-hidden ml-2">
        <ImageComponent
          src={item?.media?.url || ""}
          width={100}
          height={100}
          alt={item?.alt || "Product Image"}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>
      <h3 className="text-[13px] text-jmt-neutral-700 line-clamp-2">
        {item?.title}
      </h3>
    </Link>
  );
};

export default ProductItemSearch;
